export default __webpack_public_path__ + "media/images/casatb/tenant/casatb-colored-bg-75f75753b81ba25e8b7b7609d5197fa5.svg";